import React from 'react'
import moment from 'moment-timezone'
import DateUtil from 'lib/date-util'
import { t } from 'src/lib/i18n-react'
import { getLocale } from 'src/config/globals'
import { Box, Grid } from '@chatterbug/aaron'

import PageWrapupCard from 'src/ui/PageWrapup/subcomponents/PageWrapupCard/PageWrapupCard'
import LevelWrapupStatsItem from './subcomponents/LevelWrapupStatsItem'
import lesson from './assets/lesson.svg'
import study from './assets/study.svg'

export type Props = {
  hoursOfLessons: number
  hoursOfStudy: number
  startedAt: string
  completedAt: string
}

const LevelWrapupStats: React.FC<Props> = ({
  hoursOfLessons,
  hoursOfStudy,
  startedAt,
  completedAt,
}) => {
  const startedDate = DateUtil.format(
    DateUtil.dateFromISOString(startedAt, getLocale()),
    'cb_MMMDYYYY'
  )
  const period = t('%{smart_count} month |||| %{smart_count} months', {
    smart_count: moment(completedAt).diff(startedAt, 'months'),
  })

  return (
    <PageWrapupCard
      sx={{
        py: { _: '3x', tablet: '4x' },
        px: { _: '3x', tablet: '5x' },
      }}
    >
      <Box textAlign={{ _: 'center', tablet: 'left' }}>
        <Box
          as="p"
          variant="text.paragraph"
          dangerouslySetInnerHTML={{
            __html: t(
              'You started learning this level on <strong>%{startedDate}</strong> and it took you <strong>%{period}</strong> to complete.',
              {
                startedDate,
                period,
              }
            ),
          }}
        />
        <Box mt="4x" mb="1x" variant="text.h5">
          {t('Total hours completed')}
        </Box>
        <Grid
          gap={{
            _: '1x',
            tablet: '3x',
          }}
          columns={{ _: '1fr', tablet: '1fr 1fr' }}
        >
          <LevelWrapupStatsItem
            icon={lesson}
            label={t(
              '%{smart_count} hour of Live Lessons |||| %{smart_count} hours of Live Lessons',
              { smart_count: hoursOfLessons }
            )}
          />
          <LevelWrapupStatsItem
            icon={study}
            label={t(
              '%{smart_count} hour of study |||| %{smart_count} hours of study',
              { smart_count: hoursOfStudy }
            )}
          />
        </Grid>
      </Box>
    </PageWrapupCard>
  )
}

export default LevelWrapupStats
